import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import React from "react";
import { getDebounceInterval } from "../../pages/constants";
import { useDebounce } from "../../pages/util";

interface Props {
  onClickHandler: (searchTerm: string) => void;
}

/**
 * Search button that supports search as user types in with debounce implemented
 */
export default function SearchButton(props: Props) {
  const [searchTermTemp, setSearchTermTemp] = React.useState("");

  useDebounce(
    () => props.onClickHandler(searchTermTemp),
    [searchTermTemp],
    getDebounceInterval(),
  );

  return (
    <Box display="flex" justifyContent="flex-end">
      <Paper
        component="form"
        sx={{ display: "flex", alignItems: "center", width: 300 }}
      >
        <InputBase
          margin="dense"
          sx={{ flex: 1, marginLeft: 2 }}
          onChange={(e: any) => {
            setSearchTermTemp(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              props.onClickHandler(searchTermTemp);
            }
          }}
        />
        <IconButton
          type="button"
          onClick={() => {
            props.onClickHandler(searchTermTemp);
          }}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    </Box>
  );
}
